import React from 'react';

class Nav extends React.Component {
    render() {
        return(
            <div classname='nav'>
                <ul>
                    <li className='active'>Home</li>
                    <li>News</li>
                    <li>About</li>
                </ul>
            </div>
        )
    }
}

export default Nav;
